import { Paragraph, Show, Skeleton } from '@welbe/web-design-system';
import { Container, TrafficLights } from './EmptyPopulation.styles';

type EmptyPopulationProps = {
	loading?: boolean;
};

export const EmptyPopulation = ({ loading }: EmptyPopulationProps) => {
	return (
		<Container>
			<Show
				when={!loading}
				fallback={
					<>
						<TrafficLights>
							<Skeleton width="100%" height="40px" />
							<Skeleton width="100%" height="40px" />
							<Skeleton width="100%" height="40px" />
						</TrafficLights>
						<Skeleton width="300px" />
						<Skeleton width="448px" />
						<Skeleton width="260px" height="42px" />
					</>
				}
			>
				<Paragraph fontWeight="500">
					Aún no existen colaboradores asignados a este grupo de riesgo
				</Paragraph>
			</Show>
		</Container>
	);
};
